<template>
  <div class="image-placeholder-container">
    <div class="image-placeholder" @click="handleClick">
      <el-image v-if="image" :src="image.url" :preview-src-list="previewSrcList" fit="cover"/>
      <i class="el-icon-plus" v-else/>
    </div>
    <span
        @click.stop="handleDelete"
        v-if="showDelete && image"
        class="delete-button"
        title="删除图片"
    >
      <i class="el-icon-close"></i>
    </span>
  </div>
</template>

<script>
export default {
  name: "ImagePlaceholder",
  props: {
    image: {
      type: Object,
      default: () => null
    },
    showDelete: {
      type: Boolean,
      default: false
    },
    zoomOnClick: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    previewSrcList() {
      if (this.zoomOnClick && this.image && this.image.url) {
        return [this.image.url];
      }
      return [];
    }
  },
  methods: {
    handleClick(e) {
      if (this.zoomOnClick && this.image) {
        return;
      }
      this.$emit('click', e);
    },
    handleDelete(e) {
      e?.stopPropagation();
      this.$emit('delete');
    }
  }
}
</script>

<style lang="scss" scoped>
.image-placeholder-container {
  position: relative;
  width: 80px;
  height: 80px;
  box-sizing: content-box;
  display: inline-block;
  vertical-align: bottom;
  margin: 12px 12px 0 12px;

  .delete-button {
    position: absolute;
    top: -10px;
    right: -10px;
    background-color: #f56c6c;
    color: #ffffff;
    width: 22px;
    height: 22px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    border: 2px solid #ffffff;
    box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.2);
    cursor: pointer;
    user-select: none;
    z-index: 10;
    transition: all 0.2s;

    i {
      font-size: 12px;
    }

    &:hover {
      background-color: #f78989;
      transform: scale(1.05);
    }

    &:active {
      background-color: #dd6161;
      transform: scale(0.95);
    }
  }
}

.image-placeholder {
  width: 80px;
  height: 80px;
  box-sizing: content-box;
  border: 1px dashed #409eff;
  color: #409eff;
  background-color: #ffffff;
  text-align: center;
  line-height: 80px;
  user-select: none;
  cursor: pointer;
  transition: 200ms;

  &:hover {
    background-color: #d4e9ff;
    border-style: solid;
  }

  &:active {
    background-color: #8ec8ff;
    border-color: #5d6eee;
  }

  ::v-deep .el-image {
    width: 80px;
    height: 80px;

    .el-image__inner {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
}
</style>